// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCg9h_IBPpOpDXuu2wxE5Bx6CHfqixircU',
  authDomain: 'portfolio-de6d6.firebaseapp.com',
  projectId: 'portfolio-de6d6',
  storageBucket: 'portfolio-de6d6.appspot.com',
  messagingSenderId: '419947627628',
  appId: '1:419947627628:web:5480f6972755d136f90449',
  measurementId: 'G-DJDE16K54F',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default getFirestore();
